import { render, staticRenderFns } from "./idNormativa.vue?vue&type=template&id=55f74bdc&scoped=true&"
import script from "./idNormativa.ts?vue&type=script&lang=ts&"
export * from "./idNormativa.ts?vue&type=script&lang=ts&"
import style0 from "./idNormativa.vue?vue&type=style&index=0&id=55f74bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f74bdc",
  null
  
)

export default component.exports